import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import Swal from 'sweetalert2';
import {
  AUTH_COOKIE_KEYS,
  getAuthIdleRemainingMs,
  invalidateAuthSession,
  isAuthSessionValid,
  touchAuthActivity,
} from '../utils/authSession';

const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart'];

export default function AuthIdleWatcher() {
  const navigate = useNavigate();
  const [cookies, , removeCookie] = useCookies(AUTH_COOKIE_KEYS);

  useEffect(() => {
    const onActivity = () => {
      if (isAuthSessionValid(cookies.myToken)) {
        touchAuthActivity();
      }
    };

    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, onActivity, { passive: true });
    });

    const intervalId = window.setInterval(() => {
      if (!cookies.myToken) {
        return;
      }
      if (!isAuthSessionValid(cookies.myToken) || getAuthIdleRemainingMs() <= 0) {
        invalidateAuthSession(removeCookie);
        if (window.location.pathname !== '/') {
          navigate('/', { replace: true });
          Swal.fire({
            title: 'Session expired',
            text: 'You were logged out after 30 minutes of inactivity. Please sign in again.',
            icon: 'info',
          });
        }
      }
    }, 60000);

    return () => {
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, onActivity);
      });
      window.clearInterval(intervalId);
    };
  }, [cookies.myToken, navigate, removeCookie]);

  return null;
}
